import React, { Component } from 'react';
import { LinearProgress, CircularProgress } from '@material-ui/core';
import { ThemeSetContext } from './ThemeSet';

class LineProgress extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div style={{ width: "100%", height: "100%", position: "absolute", top: 0, left: 0 }}><LinearProgress /></div>
        );
    }
}

/**
 * @param {boolean} background 要不要有灰底
 * @param {boolean} topLayer 是否脫離父層定位，固定在 viewport 正中央（適用於 modal 內部等情境）
 */
class CircleProgress extends Component {
    constructor(props) {
        super(props);
    }

    static contextType = ThemeSetContext;

    render() {
        const themeColor = this.context.themeColor;
        const isTopLayer = this.props.topLayer === true;
        const positionStyle = isTopLayer
            ? { position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '13001' }
            : { position: 'absolute', top: '50%', left: '45%', zIndex: '3000' };
        return (
            <div className={this.props.background || this.props.background === undefined ? "circularProgress" : ""}
                style={positionStyle}>
                <div style={{ position: "relative", zIndex: "4000" }}>
                    {/* 圈圈要不要有底色 */}
                    <CircularProgress
                        variant="determinate"
                        style={{
                            color: "#e0e0e0"
                        }}
                        size={40}
                        thickness={4}
                        value={100}
                    />
                    <CircularProgress
                        variant="indeterminate"
                        disableShrink
                        style={{
                            color: themeColor?.primary,
                            animationDuration: '550ms',
                            position: 'absolute',
                            left: "0",
                            strokeLinecap: "round"
                        }}
                        size={40}
                        thickness={4}
                    />
                </div>
            </div>
        );
    }
}

export {
    LineProgress,
    CircleProgress
};